import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import giftImage from "../../assets/couponGiftIcon.png"; // update with your correct path
import { useNavigate } from "react-router-dom";

const GiftCouponCard = ({machineId}) => {

  const navigate=useNavigate()

 const  handleOrderNow=()=>{
navigate(`/items?machineId=${machineId}&showItems=true`)
  }
  return (
    <Card
      sx={{
        maxWidth: 380,
        borderRadius: "20px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        textAlign: "center",
        p: 3,
        mx: "auto",
        mt:5
      }}
    >
      <CardContent>
        {/* Image */}
        <Box
          component="img"
          src={giftImage}
          alt="Gift"
          sx={{
            width: 120,
            height: "auto",
            mx: "auto",
            display: "block",
            mb: 2,
          }}
        />

        {/* Text */}
        <Typography
          variant="body1"
          sx={{
            color: "#A56A3D",
            fontWeight: 500,
            mb: 3,
            lineHeight: 1.4,
          }}
        >
          You May Find New Gifts And <br /> Coupons On Next Order
        </Typography>

        {/* Button */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#00B272",
            color: "#fff",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "16px",
            px: 4,
            py: 1.2,
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#00925E",
            },
          }}

          onClick={e=>{handleOrderNow(e)}}
        >
          Order Now
        </Button>
      </CardContent>
    </Card>
  );
};

export default GiftCouponCard;
